import { ClbAlert } from '@celebration/react'
import { AlertProps as NxAlertProps } from '@celebration/react/ClbAlert/ClbAlert.types'
import React, { FC } from 'react'

const NxAlert: FC<NxAlertProps> = ({ type, title, description, onClose }): React.ReactElement => {
  return (
    <ClbAlert allowClose type={type} title={title} description={description} onClose={onClose} />
  )
}

export default NxAlert
